import { css } from "lit-element";

// language=CSS
export const style = css`
    :host {
        display: block;
    }
    
	.modal,
	.modal-background {
		position: fixed;
		z-index: 9999;
		left: var(--sw-dialog-simple-modal-left, 0);
		top: var(--sw-dialog-simple-modal-top, 0);
		right: var(--sw-dialog-simple-modal-right, 0);
		bottom: var(--sw-dialog-simple-modal-bottom, 0);
		width: 100%;
		height: 100%;
		overflow: auto;
	}
    
   
	.modal {
		display: table;
	}

	.modal-container {
		display: table-cell;
		vertical-align: middle;
	}
    
    .modal[relative] {
        position: absolute;
        display: block;
        overflow: visible;
    }

    .modal[relative] .modal-container {
        display: block;
        position: relative;
    }
    
	.modal-background {
		z-index: 99999;
		background-color: var(--sw-dialog-simple-background, rgba(255, 255, 255, 0.65));
	}

	.modal-content {
		padding: 40px 20px 20px;
		z-index: 999999;
		position: relative;
		background-color: var(--app-white);
		margin: var(--sw-dialog-simple-content-margin, 0 auto);
		width: var(--sw-dialog-simple-width, 50%);
		min-height: 150px;
		height: var(--sw-dialog-simple-height, 50vh);
		transform-origin: var(--sw-dialog-simple-content-transform-origin, bottom center);
		animation: zoomIn var(--sw-dialog-simple-animation-time, 0.2s) forwards cubic-bezier(0.8, 0.02, 0.45, 0.91);

		box-shadow: 0 2px 10px var(--shadow-color, rgba(0, 0, 0, 0.15));

		border-radius: var(--sw-dialog-simple-radius, 4px);

		box-sizing: border-box;
		overflow: auto;
	}

	.close {
		color: var(--app-grey);
		font-size: 28px;
		font-weight: 700;
		line-height: 28px;
		z-index: 99999;
		position: absolute;
		right: 0;
		top: 0;
		padding: 20px;
	}

	:host([no-close]) .close,
	dialog-simple[no-close] .close {
		display: none;
	}

	.close svg {
		width: 14px;
		color: var(--app-primary);
	}

	.close:hover,
	.close:focus {
		color: black;
		text-decoration: none;
		cursor: pointer;
	}

	@-webkit-keyframes zoomIn {
		0% {
			opacity: 0;
			transform: scale3d(0.3, 0.3, 0.3);
		}
		50% {
			opacity: 1;
		}
	}

	@keyframes zoomIn {
		0% {
			opacity: 0;
			transform: scale3d(0.3, 0.3, 0.3);
		}
		50% {
			opacity: 1;
		}
	}

	@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
		.modal {
			position: absolute;
		}
	}

	/* Portrait and Landscape */
	@media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) {
	}

	@media screen and (max-width: 768px) {
		.modal-content {
			margin: 0 auto;
			width: 100%;
			height: 100%;

			overflow: scroll;
		}
	}
`;
